import React from 'react';
import { setBuilderPathModeAction } from '../../../../../redux/slices/oldBuilder';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import {
  PathModeKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  pathModeTooltipOption,
  pathModeTooltips,
} from '../../../../../components/KubitTooltip/globalTooltips';
import { assertCondition } from '../../../../../utils/types';

export default () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === QueryType.Path &&
      selectedOptions?.type === QueryType.Path,
  );

  const selectedMode = selectedOptions.mode;
  const defaultModes = defaultOptions.modes;

  const handleChange = (newMode: PathModeKey) => {
    dispatch(
      setBuilderPathModeAction({
        newMode,
      }),
    );
  };

  const options = defaultModes.map((mode) => ({
    ...mode,
    tooltip: pathModeTooltips[mode.key],
  }));

  return (
    <BuilderEnumSelect
      label="Mode"
      enumOptions={options}
      selectedOption={selectedMode}
      onChange={handleChange}
      tooltipOption={pathModeTooltipOption}
    />
  );
};
